"use client";

import Link from "next/link";
import { AppBar, Box, Button, Container, Stack, Toolbar, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { PreviewBanner } from "../ui/PreviewBanner";

const items = [
  { href: "/students", label: "Murid" },
];

export function InternalShell({ children }: { children: ReactNode }) {
  return (
    <>
      <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ minHeight: 58, gap: 2, flexWrap: "wrap", py: 0.75 }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ flexGrow: { xs: 1, sm: 0 } }}>
              <Box sx={{ width: 10, height: 10, bgcolor: "secondary.main", borderRadius: "50%" }} />
              <Typography fontWeight={800}>JSA Admin</Typography>
            </Stack>
            <Stack component="nav" aria-label="Navigasi staf" direction="row" spacing={0.5} sx={{ flexGrow: 1, flexWrap: "wrap" }}>
              {items.map((item) => (
                <Button key={item.href} component={Link} href={item.href} color="inherit" size="small">
                  {item.label}
                </Button>
              ))}
            </Stack>
            <Typography variant="caption" color="text.secondary">Mode pratinjau</Typography>
          </Toolbar>
        </Container>
      </AppBar>
      <Container maxWidth="lg" sx={{ py: { xs: 1.5, sm: 2.5 }, px: { xs: 1.5, sm: 2 } }}>
        <Stack spacing={2}>
          <PreviewBanner>Data contoh saja. Login, izin server, dan penyimpanan belum tersedia.</PreviewBanner>
          {children}
        </Stack>
      </Container>
    </>
  );
}
